import React, { useEffect, useState } from "react";
import { MedalBadge } from "./ProfileStats";
import { useSounds } from "../sound";
import { t } from "../i18n";
import { socket } from "../socket";
import { announceMedals } from "../medalEvents";

// Une médaille vient d'être gravée : un bandeau glisse en haut de l'écran,
// une à la fois, avec un petit son — à la manière d'un succès Steam. Il ne
// prend jamais le focus et laisse passer les clics (pointer-events: none) :
// une réponse en cours de frappe continue comme si de rien n'était.

const TIER_MARKS = ["0", "I", "II", "III", "IV", "V"];
const SHOW_MS = 4200;


let seq = 0;

export default function MedalToaster() {
  const [queue, setQueue] = useState([]);
  const { playSuccess } = useSounds();

  useEffect(() => {
    const onMedals = (e) => setQueue(q => q.concat(e.detail.map(m => ({ ...m, key: ++seq }))));
    // En fin de partie, le serveur les pousse directement au joueur.
    const onSocket = (medals) => announceMedals(medals);
    window.addEventListener("pq:medals", onMedals);
    socket.on("medalsEarned", onSocket);
    return () => {
      window.removeEventListener("pq:medals", onMedals);
      socket.off("medalsEarned", onSocket);
    };
  }, []);

  const current = queue[0];
  useEffect(() => {
    if (!current) return undefined;
    playSuccess();
    const id = setTimeout(() => setQueue(q => q.slice(1)), SHOW_MS);
    return () => clearTimeout(id);
  }, [current?.key]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!current) return null;
  const tiered = (current.tierCount || 1) > 1;
  return (
    <div key={current.key} class="medal-toast" role="status" aria-live="polite"
      style={{ animationDuration: `${SHOW_MS}ms` }}>
      <MedalBadge medal={{ ...current, unlocked: true, cond: null }} size={46} />
      <div class="medal-toast-text">
        <span class="medal-toast-kicker">
          {t("medals.toastKicker")}
          {tiered && <> · {t("medals.toastTier", { tier: TIER_MARKS[current.tier] || "0" })}</>}
        </span>
        <strong class="medal-toast-name">{current.name}</strong>
      </div>
    </div>
  );
}
